import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { collectionsApi } from '../../api/endpoints/collections';
import { PaymentReminderRequest, CollectionActionRequest } from '../../api/types/collection.types';

export const useDueLoans = (daysOverdue?: number) => {
  return useQuery({
    queryKey: ['collections', 'due', daysOverdue],
    queryFn: () => collectionsApi.getDueLoans({ daysOverdue }),
  });
};

export const useSendReminder = () => {
  return useMutation({
    mutationFn: (data: PaymentReminderRequest) => collectionsApi.sendReminder(data),
  });
};

export const useLogCollectionAction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CollectionActionRequest) => collectionsApi.logAction(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['collections'] });
    },
  });
};
